<template>
    <div class="cc-cofiscz-toptrans" @click.prevent.stop>
        <div class="cc-cofiscz-toptrans__header">
            <div class="cc-cofiscz-toptrans__title mb-2">{{ selectedAddress }}</div>
            <button id="cofiscz-toptrans-msg" class="cc-button cc-button--delivery-branch btn btn-primary" @click.stop="openWidget">{{ buttonName }}</button>
        </div>
        <div class="cc-cofiscz-toptrans__main" v-if="isWidgetVisible">
            <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
                <div class="cc-popup__content">
                    <div class="cc-popup__header">
                        <div class="cc-popup__title">{{ translations['Select delivery address'] }}</div>
                    </div>
                    <label for="Toptrans.psc" class="cc-label cc-label--text">{{ translations['Postal code'] }}</label>
                    <the-mask v-if="postalCodeMask" ref="postalCode" id="postalCode" type="text" name="invoiceAddress.postalCode" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.postalCode}" :value="user.deliveryAddress.postalCode" :placeholder="`${translations['Postal code']}*`" :mask="postalCodeMask" autocomplete="off" @change.native="updatePostalCode" @keyup.enter.native="done"/>
                    <input v-if="!postalCodeMask" ref="postalCode" id="Toptrans.psc" name="Toptrans.psc" type="text" class="cc-input cc-input--text" @change="updatePostalCode" @keyup.enter.native="done"/>
                    <div class="cc-popup__footer">
                        <button class="cc-button cc-button--popup-cancel btn btn-secondary" @click.prevent.stop="closeWidget">{{ translations['Cancel'] }}</button>
                        <button class="cc-button cc-button--popup-ok btn btn-success" @click.prevent.stop="done">{{ translations['Continue'] }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import TheMask from "@/components/_common/TheMask/TheMask";

    export default {
        components: {
            TheMask
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                cofisczToptrans: state => state.cofisczToptrans,
                user: state => state.user,
                countries: state => state.config.countries
            }),
            buttonName: function () {
                return this.selectedAddress !== "" ? this.translations['Change'] : this.translations['Select branch'];
            },
            isWidgetVisible: function () {
                if (this.selectedCarrier === null) {
                    return this.shouldWidgetBeShown;
                }
                if (this.selectedCarrier.module === 'cofiscztoptrans' && (this.user.deliveryAddress.postalCode === "" || this.carrier.price_tax_exc == 0)) {
                  this.$nextTick(function () {
                    this.$refs.postalCode.$el.focus();
                  }.bind(this));

                  return true;
                }

                return this.shouldWidgetBeShown;
            },
            postalCodeMask: function () {
              for (let key in this.countries) {
                if (!this.countries.hasOwnProperty(key)) {
                  continue;
                }

                if (parseInt(this.countries[key].id) === parseInt(this.user.deliveryAddress.country)) {
                  return this.countries[key].zip_format;
                }
              }

              return null;
            },
            selectedAddress: function () {
                if(this.user.deliveryAddress.postalCode === "") {
                    return "";
                } 

                return this.user.deliveryAddress.postalCode
            }
        },
        data: function () {
            return {
                shouldWidgetBeShown: false
            };
        },
        methods: {
            openWidget: function () {
                this.shouldWidgetBeShown = true;
                this.$emit('selectCarrier', this.carrier);
                this.$nextTick(function () {
                    this.$refs.postalCode.$el.focus();
                }.bind(this));
            },
            closeWidget: function () {
                this.shouldWidgetBeShown = false;
                if(this.user.deliveryAddress.postalCode === "" || this.carrier.price_tax_exc == 0) {
                    this.$emit('closeWithoutParcelShop');
                    location.reload();
                }
            },
            updatePostalCode(e) {
                this.$store.dispatch('UPDATE_POSTAL_CODE', e.target.value);
            },
            done: function () {
                this.shouldWidgetBeShown = false;
                this.$emit('selectCarrier', this.carrier);
                this.$store.commit('SET_LOCK_DELIVERY_POSTAL_CODE',true);
                this.$emit('priceLoadingStart');

                const body = document.getElementsByTagName('body')[0];
                const coverSpin = document.createElement('div');
                coverSpin.id = 'cart-cover-spin';
                body.appendChild(coverSpin);

                this.$store.dispatch('UPDATE_ADDRESSES')
                .then(() => {
                    document.getElementById('cart-cover-spin').remove();
                    this.$emit('priceLoadingDone');
                    this.shouldWidgetBeShown = false;
                    if(this.carrier.price_tax_exc == 0)
                    {
                        this.$store.dispatch('UPDATE_POSTAL_CODE', "");
                        this.$store.commit('SET_LOCK_DELIVERY_POSTAL_CODE',false);
                        this.$emit('closeWithoutParcelShop');
                        alert(this.translations['TopTrans did not find the selected address']);
                    }
                });
            }
        },
        name: 'CofisczToptrans',
        props: [
            'carrier',
            'selectedCarrier',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
  @import "../../../_common/scss/popups";
  @import "../../../_common/scss/tables";
  #app {
    .cc-table {
      margin-top: 1rem;
    }
  }
  .cc-input.cc-input--text {
    padding: 1rem;
  }
  #app .cc-table__td {
    padding: 0.5rem 1rem;
  }
  .cc-cofiscz-toptrans .cc-table__tr {
    border-top: 1px solid #eeeeee;
  }
  .cc-button {
    white-space: nowrap;
  }

  /* big widget */
  #app .cc-cofiscz-toptrans__main--big .cc-popup__content {
    top: auto;
    left: auto;
    -webkit-transform: none;
    transform: none;
    min-width: calc(100% - 2rem);
    max-width: 100%;
    padding: 0;
  }

  #app .cc-popup__main {
    padding: 0;
  }

</style>
